import { InjectionToken } from '@angular/core';

export enum RouterMenu {
  ACCESSIBILITY = 'accessibility',
  CASES = 'cases',
  COOKIES = 'cookies',
  DEPOSIT = 'deposit',
  ERROR = 'error',
  GLOBAL_POSITION = 'global-position',
  HELP = 'help',
  LEGAL_WARNING = 'legal-warning',
  LOGIN = 'login',
  PERSONAL_DATA = 'personal-data',
  PRIVATE_AREA = 'private-area',
  PSD = 'PSD2',
  SECURITY = 'security',
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  TRANSFER = 'transfer',
  TRANSACTIONS = 'transactions',
  VIRTUAL_MAILBOX = 'virtual-mailbox',
  DOCUMENTATION = 'documentation',
}

export type RouterMenuTypes = typeof RouterMenu;

export const ROUTING_MENU = new InjectionToken('ROUTING_MENU', {
  providedIn: 'root',
  factory: () => RouterMenu
});
